import {
  LOCAL_CONTACT,
  PROPERTY_MANAGEMENT_OPTIONS,
} from 'src/components/payment/constants';
import { RentalStructureValues } from './configuration';
import { Person } from './person';
import { FLOWS_ENUM } from 'src/common/enums';
import { SupplementalQuestion } from './supplementalQuestions';

export enum FLOW_DIRECTION {
  BACK,
  FORWARD,
}

export interface IFlowState {
  applicationData?: ApplicationData;
  applicationNumber: string;
  documentUploadCompleted: boolean;
  documentUploadErrors: string[];
  documentUploadStarted: boolean;
  documentUploadWorking: boolean;
}
export interface RenewState extends IFlowState {
  fee?: number;
  initiatingRenewFlow: boolean;
  initiatingRenewFlowError: string;
  lateRenewalData: unknown; // if populated should have properties of hasExpired, expirationDate and renewBy (used on confirmation page f there are late fees)
  renewLicenseError: string;
  renewLicenseInProgress: boolean;
  selectedBulkRenewalLicenses: Array<unknown>;
}

export interface UpdateState extends IFlowState {
  initiatingUpdateFlow: boolean;
  initiatingUpdateFlowError: string;
  updateLicenseInProgress: boolean;
  updateLicenseError: string;
}

export interface ApplyState
  extends Pick<IFlowState, 'applicationNumber' | 'applicationData'> {
  applicationError: string;
  applicationFinished: boolean;
  applicationLoading: boolean;
}

export interface Certification {
  signatory: string;
  mandatoryAcknowledgements: Record<string, { label: string; value: boolean }>;
}

export interface DocumentObject {
  required: boolean;
  attachedFiles: Array<{ blobFile: File; name: string }>;
}
export type Document = Record<string, DocumentObject>;

export interface ContactsState {
  propertyManager?: Person;
  localContact?: Person;
  selectedManagementOption: PROPERTY_MANAGEMENT_OPTIONS;
  selectedOwnerRepOption: LOCAL_CONTACT;
}

export interface PropertyDetails extends Record<string, unknown> {
  address?: string;
  apn?: string;
  supplementalQuestions?: Record<string, SupplementalQuestion>;
}

export interface ApplicationData {
  certifications?: Certification;
  contacts?: ContactsState;
  documents?: Document;
  listings?: Array<string>;
  property?: Property;
  propertyDetails?: PropertyDetails;
  registrant?: Registrant;
  tenant?: Person;
}

export interface Property {
  propertyaddress: string;
  propertyid: string;
  unitnumber: string;
  rentalstructure: RentalStructureValues;
  isResidential: boolean;
}
export interface Registrant {
  registrantType: REGISTRANT_OPTIONS;
  owner: Array<Person>;
  registrant: Person;
}

export enum REGISTRANT_OPTIONS {
  OWNER = 'owner',
  PROPERTY_MANAGER = 'propertyManager',
  PROPERTY_MANAGER_INDEPENDENT = 'propertyManagerIndependent',
  TENANT = 'tenant',
}

export enum RegistrantType {
  INDIVIDUAL = 'individual',
  BUSINESS = 'business',
  PROPERTY_MANAGER = 'property_manager',
  PROPERTY_OWNER = 'property_owner',
}

export interface UploadConfiguration {
  document: string;
  uploadToken: string;
  files: DocumentObject;
}

export interface Step {
  stepNum: number;
  isCompleted?: boolean;
  key: string;
  stepName?: string;
}

export interface FlowState {
  steps: Array<Step>;
  currentStep: number;
  nextStepPath: string;
  prevStepPath: string;
  direction?: FLOW_DIRECTION;
  originPath: string;
  currentFlow?: FLOWS_ENUM;
}
